var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "repeat-option-set repeat-option-set--yearly" },
    [
      _c("div", { staticClass: "repeat-option-set-section" }, [
        _c(
          "div",
          { staticClass: "repeat-option-set-section__grid" },
          _vm._l(_vm.options, function(option) {
            return _c(
              "button",
              {
                key: option.value,
                staticClass: "repeat-option-set-section-grid-item",
                class: { primary: option.selected },
                on: {
                  click: function($event) {
                    return _vm.toggleByMonth(option.value)
                  }
                }
              },
              [_vm._v("\n\t\t\t\t" + _vm._s(option.label) + "\n\t\t\t")]
            )
          }),
          0
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "repeat-option-set-section repeat-option-set-section--on-the-select"
        },
        [
          _c(
            "ActionCheckbox",
            {
              staticClass: "repeat-option-set-section__title",
              attrs: { checked: _vm.isBySetPositionEnabled },
              on: { change: _vm.toggleBySetPosition }
            },
            [
              _vm._v(
                "\n\t\t\t" + _vm._s(_vm.$t("calendar", "On the")) + "\n\t\t"
              )
            ]
          ),
          _vm._v(" "),
          _c("RepeatFirstLastSelect", {
            attrs: {
              "by-set-position": _vm.bySetPosition,
              disabled: !_vm.isBySetPositionEnabled
            },
            on: { change: _vm.changeBySetPosition }
          }),
          _vm._v(" "),
          _c("RepeatOnTheSelect", {
            attrs: {
              "by-day": _vm.byDay,
              disabled: !_vm.isBySetPositionEnabled
            },
            on: { change: _vm.changeByDay }
          })
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }